import { FormProvider, useForm } from "react-hook-form";
import { Button } from "react-bootstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import SearchIcon from "@mui/icons-material/Search";
import { busquedaPorRangoDeFechas } from "./schemas";
import { handleBusquedaPorRangoDeFechas } from "./handlers";
import DateInput from "../../../components/ReactHookForm/DateInput";
import { MuniSpinner2 } from "../../../components";

const FormCamarasPorRango = (props) => {
  const { setCamaras } = props;
  const methods = useForm({
    mode: "all",
    resolver: yupResolver(busquedaPorRangoDeFechas),
  });

  return (
    <FormProvider {...methods}>
      <form
        className="d-flex flex-column gap-0 flex-sm-row gap-2 gap-sm-4"
        onSubmit={methods.handleSubmit((data) =>
          handleBusquedaPorRangoDeFechas(data, setCamaras, methods.setError)
        )}
      >
        <div style={{ maxWidth: "320px" }}>
          <DateInput
            label="Fecha de Inicio *"
            name="fecha_inicio"
            register={methods.register}
            errors={methods.formState.errors?.fecha_inicio}
          />
        </div>
        <div style={{ maxWidth: "320px" }}>
          <DateInput
            label="Fecha Fin *"
            name="fecha_fin"
            register={methods.register}
            errors={methods.formState.errors?.fecha_fin}
          />
        </div>
        <div style={{ maxWidth: "320px" }}>
          <Button
            type="submit"
            disabled={methods.formState.isSubmitting}
            style={{
              height: "38px",
              marginTop: "32px",
            }}
          >
            <SearchIcon />
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};

export default FormCamarasPorRango;
